import {
    type BoxProductDetailsResponseDto,
    type ProductControllerGetProductDetails200Response,
} from '@jsmdg/experience-product-backend-api-client-javascript-axios';
import { type ExperienceProductDetailsResponseDto } from '@jsmdg/experience-product-backend-api-client-javascript-axios/api';
import { type ValueVoucherResourceWithPriceRangeEnabledResponseDto } from '../server/types/types';
import { ProductType } from './enums';
import {
    type Box,
    type Experience,
    type Product,
    type ValueVoucher,
    type ValueVoucherWithPriceRange,
} from './types';

function isBox(product: Product): product is Box {
    return product.type === ProductType.BOX;
}

function isExperience(product: Product): product is Experience {
    return product.type === ProductType.EXPERIENCE;
}

function getBookableLocationsCount(product: Product): number {
    return isExperience(product) ? product.bookableLocationsCount : 0;
}

function isValueVoucher(product: Product): product is ValueVoucher {
    return product.type === ProductType.VALUE_VOUCHER;
}

function isValueVoucherWithPriceRange(product: Product): product is ValueVoucherWithPriceRange {
    return product.type === ProductType.VALUE_VOUCHER && product.priceHasRange;
}

function isExperienceResource(
    product: ProductControllerGetProductDetails200Response,
): product is ExperienceProductDetailsResponseDto {
    return product.type === ProductType.EXPERIENCE;
}

function isBoxResource(
    product: ProductControllerGetProductDetails200Response,
): product is BoxProductDetailsResponseDto {
    return product.type === ProductType.BOX;
}

function isValueVoucherWithPriceRangeResource(
    product: ProductControllerGetProductDetails200Response,
): product is ValueVoucherResourceWithPriceRangeEnabledResponseDto {
    return (
        product.type === ProductType.VALUE_VOUCHER &&
        'priceRange' in product &&
        product.priceRange.enabled
    );
}

export {
    getBookableLocationsCount,
    isBox,
    isBoxResource,
    isExperience,
    isExperienceResource,
    isValueVoucher,
    isValueVoucherWithPriceRange,
    isValueVoucherWithPriceRangeResource,
};
